(function () {
  var root = document.documentElement;
  var mq = matchMedia('(prefers-color-scheme: dark)');

  function isDark() {
    return root.dataset.theme ? root.dataset.theme === 'dark' : mq.matches;
  }

  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    function sync() {
      btn.setAttribute('aria-pressed', String(isDark()));
    }
    btn.addEventListener('click', function () {
      root.dataset.theme = isDark() ? 'light' : 'dark';
      try { localStorage.setItem('theme', root.dataset.theme); } catch (e) {}
      sync();
    });
    mq.addEventListener('change', sync);
    sync();
  });

  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input[type="search"]').focus();
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10);
      input.value = Math.max(parseInt(input.min, 10) || 0, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset;
        main.alt = thumb.dataset.alt;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var submit = form.querySelector('[type="submit"]');
    var price = document.querySelector('[data-product-price]');
    select.addEventListener('change', function () {
      var opt = select.selectedOptions[0];
      submit.disabled = opt.dataset.available !== 'true';
      submit.textContent = opt.dataset.available === 'true' ? submit.dataset.addLabel : submit.dataset.soldLabel;
      if (price) price.textContent = opt.dataset.price;
      var url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState(null, '', url);
    });
  });

  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      location.href = url;
    });
  });

  var reveal = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || !reveal.length) return;
  root.classList.add('js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.1 });
  reveal.forEach(function (el) { io.observe(el); });
})();
